import { render, staticRenderFns } from "./growthAdsStatus.vue?vue&type=template&id=4e55d0dc&scoped=true"
import script from "./growthAdsStatus.vue?vue&type=script&lang=js"
export * from "./growthAdsStatus.vue?vue&type=script&lang=js"
import style0 from "./growthAdsStatus.vue?vue&type=style&index=0&id=4e55d0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55d0dc",
  null
  
)

export default component.exports